import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

let messages = {
  'messages': {
    'es-MX': {
        'moduleTitle': 'Portal administrativo',
    },
    'en': {
      'moduleTitle': 'Admin portal',
    }
  }
}

export default _.merge(messages, defaultMessages)
